{
  "comment": "M10 P5a9a: cradle docking tuning (an S docking into a holding L's DOCK_CRADLE; plan 2026-10-17-m10-p5a, Q9). requestRangeM is the range from the L at which the dock key may request its cradle (= strategic/local.json dockStartM). The cradle accepts only while the L holds: speed at or under moor.json holdSpeedMps and turn rate at or under holdTurnDegS. launchSpeedMps is the release speed out through the cradle mouth (the socket out axis, +Y on the Gannet) on launch; unloadS is the unload time once cradled (0 = instant). Every value is [P].",
  "requestRangeM": 2000,
  "holdTurnDegS": 1,
  "launchSpeedMps": 6,
  "unloadS": 0
}
